import { combineReducers } from 'redux'
import mainReducer from './containers/Main/reducer'

export default combineReducers({mainReducer})
